import type { FC } from "react";

import { Form } from "@/ui/components/form/Form";
import { Input } from "@/ui/components/form/Input";
import { Password } from "@/ui/components/form/Password";
import { Column } from "@/ui/components/layout/Column";
import { Grid } from "@/ui/components/layout/Grid";
import { Button } from "@/ui/components/primitives/Button";
import {
  LOGIN_DEFAULTS,
  LOGIN_FORGOT_PASSWORD_LINK_CLASS,
  type TLoginProps,
} from "@/ui/components/sections/authentication/forms/Login/Login.config";
import {
  useLoginWithPassword,
} from "@/ui/components/sections/authentication/forms/Login/useLoginWithPassword";
import { cn } from "@/ui/lib/utils";

export const LoginWithPassword: FC<TLoginProps> = (
  {
    email,
    password,
    forgotPassword,
    submit,
    onSubmit,
    noValidate = LOGIN_DEFAULTS.noValidate,
    className,
    children,
    ...props
  },
) => {
  const {
    emailProps,
    forgotPassword: resolvedForgotPassword,
    passwordProps,
    submitLabel,
    submitProps,
  } = useLoginWithPassword({
    email,
    password,
    forgotPassword,
    submit,
  });

  return (
    <div
      data-component="Login"
      className="w-full"
    >
      <Form
        {...props}
        noValidate={noValidate}
        onSubmit={onSubmit}
        className={cn(
          "w-full",
          className,
        )}
      >
        <Grid gap="4">
          <Column className="w-full">
            <Input
              {...emailProps}
            />
          </Column>
          <Column className="w-full">
            <Password
              {...passwordProps}
            />
          </Column>
          <Column className="w-full justify-end">
            <a
              href={resolvedForgotPassword.href}
              className={LOGIN_FORGOT_PASSWORD_LINK_CLASS}
            >
              { resolvedForgotPassword.label }
            </a>
          </Column>
          { children && (
            <Column className="w-full">
              { children }
            </Column>
          ) }
          <Column className="w-full">
            <Button
              {...submitProps}
              type="submit"
            >
              { submitLabel }
            </Button>
          </Column>
        </Grid>
      </Form>
    </div>
  );
};

LoginWithPassword.displayName = "LoginWithPassword";
